import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import mailingActions from '../actions/mailingInformation';

function updateMailingDetails(store, action) {
    const {
        mailingDetails,
        isBillingSetupFlow
    } = action.payload;
    request.post(`/${config.url_prefix}/api/updateAddress?isBillingSetupFlow=${isBillingSetupFlow}`)
        .send({
            data: mailingDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(mailingActions.alertError('internal.server.error'));
            } else if (response.statusCode === 204) {
                if (isBillingSetupFlow) {
                    store.dispatch(actions.changeAppState('COMPANY_LOCATION'));
                } else if (store.getState().app.dyff?.SHARED_IPM_BANKING_ENABLED) {
                    store.dispatch(actions.changeAppState('BUSINESS_MODEL'));
                } else {
                    store.dispatch(actions.changeAppState('SUMMARY'));
                }
            } else {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(mailingActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default updateMailingDetails;
